var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"mb-0 text-secondary font-weight-bold"},[(_vm.icon)?_c('i',{class:_vm.icon + ' mr-1'}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }